import httpRequest from '../utils/httpRequest';
import API from '@/api';

const SERVER_NAME = 'core';

export async function getPackageVersion() {
    return httpRequest({
        url: `${API.base}version.json`,
        method: 'get',
        params: {
            v: `${new Date().getTime()}`,
        },
    });
}

/**
 * 登录
 * @param {Object} data
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 */
export function login(data) {
    return httpRequest(
        {
            url: '/user/login',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            resolveError: true,
        }
    );
}

/**
 * 获取图片验证码
 */
export function getGraphVerifyCode(data) {
    return httpRequest(
        {
            url: '/user/getGraphVerifyCode',
            serverName: SERVER_NAME,
            method: 'post',
            data,
            headers: {
                applicationCode: '1000',
            },
        },
        { closeErrorMessage: true }
    );
}

/**
 * 退出登录
 */
export function logout() {
    return httpRequest({
        url: '/user/logout',
        serverName: SERVER_NAME,
        method: 'get',
        headers: {
            applicationCode: '1000',
        },
    });
}

/**
 * 数据字典-搜索字典
 * @param {Object} data
 * @param {string | Null} [data.name] - 字典名称
 */
export function queryDictionary(data) {
    return httpRequest(
        {
            url: '/dictionary/query',
            serverName: SERVER_NAME,
            method: 'post',
            data,
        },
        {
            closeErrorMessage: true,
        }
    );
}
/**
 * 数据字典-搜索字典
 * @param {Object} data
 * @param {string | Null} [data.name] - 字典名称
 * @param {string | Null} [data.code] - 字典名称
 */
export function dictionarySave(data) {
    return httpRequest({
        url: '/dictionary/save',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}
/**
 * 数据字典-搜索字典
 * @param {Object} params
 * @param {string | Null} params.id - 字典id
 */
export function dictionaryDelete(params) {
    return httpRequest({
        url: '/dictionary/delete',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 数据字典-查询字典详情
 * @param {Object} data
 * @param {string} data.dictionaryId - 字典id
 * @param {number} data.pageNum - 页码
 * @param {number} data.pageSize - 条目数
 */
export function queryDictionaryValue(data) {
    return httpRequest({
        url: '/dictionary-value/query',
        serverName: SERVER_NAME,
        method: 'post',
        headers: {
            applicationCode: '1000',
        },
        data,
    });
}

/**
 * 数据字典-保存
 * @param {Object} data
 * @param {string} data.applicationId - 应用id
 * @param {string} [data.code] - 字典值code
 * @param {string} data.id - 字典值id
 * @param {string} data.value - 字典值code
 * @param {string} data.dictionaryId - 字典id
 * @param {string} data.name - 字典值name
 * @param {string} data.dictionaryCode - 字典code
 * @param {string} data.dictionaryName - 字典name
 * @param {number} data.pageNum - 页码
 * @param {number} data.pageSize - 条目数
 */
export function queryDictionarySave(data) {
    return httpRequest({
        url: '/dictionary-value/save',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 数据字典-保存
 * @param {Object} params
 * @param {string} params.id - 字典值id
 */
export function queryDictionaryDelete(params) {
    return httpRequest({
        url: '/dictionary-value/delete',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 应用管理-列表
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function getApplicationList(data) {
    return httpRequest({
        url: '/application/query',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 资源管理-树形列表
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function getResourceTree(data) {
    return httpRequest({
        url: '/resource/queryResourceAll',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 资源管理-查询应用下的树形列表
 * @param {Object} params
 * @return {Promise<*>|*}
 */
export function getApplicationResource(params) {
    return httpRequest({
        url: '/resource/queryTree',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 资源管理-新增
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function resourceAdd(data) {
    return httpRequest({
        url: '/resource/add',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 资源管理-修改
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function resourceUpdate(data) {
    return httpRequest({
        url: '/resource/update',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 资源管理-删除
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function resourceDelete(params) {
    return httpRequest({
        url: '/resource/delete',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 用户分页查询
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function queryUser(data) {
    return httpRequest({
        url: '/user/query',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 用户分页查询
 * @param {Object} params
 * @return {Promise<*>|*}
 */
export function getUser(params) {
    return httpRequest({
        url: '/user/get',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 用户新增
 * @param {Object} data
 */
export function saveUser(data) {
    return httpRequest({
        url: '/user/save',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 删除用户
 * @param {Object} params
 * @return {Promise<*>|*}
 */
export function delUser(params) {
    return httpRequest({
        url: '/user/delete',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 重置密码
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function resetUserPassword(data) {
    return httpRequest({
        url: '/user/resetPassword',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 批量删除用户
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function deleteByIds(data) {
    return httpRequest({
        url: '/user/deleteByIds',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 根据code获取配置
 * @param {Object} data
 * @return {Promise<*>|*}
 */
export function getConfig(params) {
    return httpRequest({
        url: '/config/get',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
